export const FiddyAdminDashboard = () => {
  return (
    <div className="container p-6 mx-auto">
      <h1 className="mb-6 text-3xl font-bold">Admin Panel - TURBO FIDDY 3001</h1>
      <div className="grid gap-6">
        <div className="p-6 bg-white rounded-lg shadow">
          <h2 className="mb-4 text-xl font-semibold">Dashboard</h2>
          <p>
            Ce dashboard est vide pour l'instant, dans le futur il sera tout plein de belles
            features
          </p>
        </div>
      </div>
    </div>
  );
};
